import React from "react";

import { IWithDialogsProps, withDialogs } from "@/eworkitComponents";

import { Dialog } from "./Dialog";

interface Props extends IWithDialogsProps {}

export class DialogsComponent extends React.PureComponent<Props> {
  render() {
    const { dialogs, deleteDialog } = this.props;

    if (!dialogs.length) {
      return null;
    }

    return dialogs.map(dialog => (
      <Dialog key={dialog.id} open={true} size="sm" onClose={() => deleteDialog(dialog)} {...dialog} />
    ));
  }
}

export const Dialogs = withDialogs(DialogsComponent);
